export default __webpack_public_path__ + "static/media/logo-full.77bddf13.svg";